module.exports = __webpack_public_path__ + "static/img/13.377178c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/zh/13.png
// module id = kz3E
// module chunks = 0